import { Box, Grid, Typography } from "@mui/material";
import CardWithFooter, { CardFooterButton } from "components/CardWithFooter";
import { useTranslation } from "react-i18next";
import EyeIcon from "@mui/icons-material/Visibility";
import { useDocumentsIndex } from "queries/documents";
import { download } from 'queries/http';

const CustomerJourneysIndexPage = () => {
  const { t } = useTranslation();
  const { data: documents } = useDocumentsIndex();
  if (!documents) return null;

  return (
    <Box>
      {}
      <Typography component="h1" sx={{ mt: 4 }} variant="h6">
        {t("customerJourneys.index.list")}
      </Typography>
      <Grid container spacing={3} mt={0}>
        {documents.map((document) => (
          <Grid key={document.id} item sm={4} xs={12}>
            <CardWithFooter
              body={
                <>
                  <Typography fontWeight={700} fontSize="16px">
                    {document.name}
                  </Typography>
                  <Typography fontWeight={500} fontSize="10px">
                    {document.description}
                  </Typography>
                </>
              }
              actions={
                <>
                  <CardFooterButton
                    Icon={EyeIcon}
                    text={t("overview")}
                      onClick={() => download(document.contentUrl,document.filename)}
                    sx={{ mx: "auto" }}
                  />
                </>
              }
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CustomerJourneysIndexPage;
